<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de rubro</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de Rubros</option>        
        <option v-for="(tipoRubro,index) in tiposRubros" :value="tipoRubro.TipoRubroId" :key="index">{{tipoRubro.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposRubros: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      quitarRubros: Array
    },
    propData:{
      //quitarRubros: [1,5]//para probar
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 006TiposRubros
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }

        this.$store.dispatch("A_SIVAC_Catalogos_006TiposRubros",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento);
        //console.log(valoresDelCatalogo.llave);
        //console.log(valoresDelCatalogo);
        // para obtener label del select => let labelTipoPagina = evento.target.options[evento.target.selectedIndex].text;
      },
      /**
       * Metodo para lenar catalogo 006TiposRubros mediante el llamado de la API
       */
      cargarTiposRubros: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API_AGREGAR = api.SIVAC.catalogos.C006TiposRubros;
        //console.log(METODO_API_AGREGAR);
        let urlApi = SERVIDOR + METODO_API_AGREGAR;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        let peticionMetodoGetTiposRubrosAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetTiposRubrosAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        /* utilizar solo en etapa de desarrollo 
                        console.log("ejecuto bien paginas controller:: ",respuesta.data); */
                        this.tiposRubros = respuesta.data.tiposRubro;
                        if(this.quitarRubros != null)
                        this.quitarRubros.forEach((quitar) => {
                            this.tiposRubros.forEach((rubro, index) => {

                                if(quitar === rubro.TipoRubroId){
                                   delete this.tiposRubros[index]
                                }
                            })                          
                        })
                        this.tiposRubros = this.tiposRubros.filter(el => Object.keys(el).length)
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      //console.log(this.valorDefinido);
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SIVAC_Catalogos_006TiposRubros", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposRubros();
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Catalogos/C006TiposRubro.vue